import React, { useState, useEffect } from 'react';
import Processus from '../components/Processus';
import globals from '../Globals'
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import BestSellersCarousel from './bestSeller';
import PopularDestinations from '../components/PopularDestinations';

// Fallback images used until the back-office ones load (or if none are configured)
const defaultImages = [
    "assets/img/dest1.jpg",
    "assets/img/background2.png",
    "assets/img/dest2.jpg",
    "assets/img/sport2.jpg",

];
const API = globals.API
export default function Home() {
    const [heroImages, setHeroImages] = useState(defaultImages);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [firstImageReady, setFirstImageReady] = useState(false);
    const [featuredEvents, setFeaturedEvents] = useState([]);
    const [sportEvents, setSportEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedBestSeller, setSelectedBestSeller] = useState(null);
    const [showBestSellerModal, setShowBestSellerModal] = useState(false);
    const [specificRequest, setSpecificRequest] = useState("");
    const [showOtherInput, setShowOtherInput] = useState(false);
    const [pendingHash, setPendingHash] = useState(null);


    useEffect(() => {
        // Preload all carousel images; mark ready after first one loads
        heroImages.forEach((src, i) => {
            const img = new Image();
            if (i === 0) { img.onload = img.onerror = () => setFirstImageReady(true); }
            img.src = src;
        });
    }, [heroImages]);

    useEffect(() => {
        // Load hero images configured from the back-office; keep defaults if none/error
        let cancelled = false;
        (async () => {
            try {
                const res = await fetch(`${API}/settings`);
                const data = await res.json();
                const urls = (data?.heroImages || []).map(i => i.url).filter(Boolean);
                if (!cancelled && urls.length > 0) {
                    setHeroImages(urls);
                    setCurrentImageIndex(0);
                }
            } catch { /* keep defaults */ }
        })();
        return () => { cancelled = true; };
    }, []);

    const handleSpecificRequestChange = (e) => {
        setSpecificRequest(e.target.value);
        setShowOtherInput(e.target.value === "autres");
    };

    // We fetch up to 8 events from the backend now

    // Best Sellers Data
    const bestSellers = [
        {
            id: 1,
            title: "La Colombie",
            destination: "Bogotá • Medellín • Carthagène",
            image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&h=600&fit=crop",
            duration: "Départs tous les premiers dimanches du mois",
            minPersons: "2 personnes",
            description: "Partez à la découverte de la Colombie, un pays vibrant où se mêlent culture, nature, histoire et ambiance tropicale ! De Bogotá la capitale culturelle perchée dans les Andes, à Medellín, symbole de renaissance et d'innovation, jusqu'à Carthagène des Indes, joyau colonial des Caraïbes… ce circuit offre une immersion complète au cœur de l'âme colombienne.",
            highlights: [
                "Un itinéraire complet combinant culture, nature et détente",
                "Trois villes emblématiques : Bogotá, Medellín et Carthagène",
                "Visite de sites incontournables : Cerro de Monserrate, Comuna 13, Peñol & Guatapé",
                "Expériences uniques : téléphérique, street art, villages colorés",
                "Accompagnement local professionnel et départs garantis"
            ]
        },
        {
            id: 2,
            title: "Argentine",
            destination: "Buenos Aires • Iguazú • Patagonie",
            image: "https://images.unsplash.com/photo-1589909202802-8f4aadce1849?w=800&h=600&fit=crop",
            duration: "Départs tous les premiers dimanches du mois",
            minPersons: "2 personnes",
            description: "L'Argentine séduit par la diversité de ses paysages et la richesse de sa culture. De la vibrante capitale Buenos Aires, berceau du tango et de la gastronomie, aux impressionnantes chutes d'Iguazú nichées au cœur de la jungle subtropicale, jusqu'aux immenses glaciers de Patagonie.",
            highlights: [
                "Découverte de Buenos Aires, capitale élégante et culturelle",
                "Spectacle de tango dans une ambiance traditionnelle",
                "Exploration des majestueuses chutes d'Iguazú",
                "Immersion dans la Patagonie et visite du glacier Perito Moreno",
                "Programme complet combinant nature, culture et émotion"
            ]
        },
        {
            id: 3,
            title: "Argentine & Brésil",
            destination: "Buenos Aires • Iguaçu • Rio de Janeiro",
            image: "https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=800&h=600&fit=crop",
            duration: "Départs tous les premiers dimanches du mois",
            minPersons: "2 personnes",
            description: "Un circuit combiné exceptionnel entre deux pays mythiques d'Amérique du Sud : Découvrez la passion et l'élégance de Buenos Aires, la puissance spectaculaire des chutes d'Iguaçu, puis terminez sous le soleil de Rio de Janeiro, capitale mondiale de la samba.",
            highlights: [
                "Visite complète de Buenos Aires, capitale du tango",
                "Dîner-spectacle typique pour vivre la passion argentine",
                "Découverte des chutes d'Iguaçu côté argentin et brésilien",
                "Séjour à Rio entre plages mythiques et sites emblématiques",
                "Voyage équilibré combinant culture, détente et nature"
            ]
        },
        {
            id: 4,
            title: "Brésil",
            destination: "São Paulo • Rio de Janeiro",
            image: "https://images.unsplash.com/photo-1516306580123-e6e52b1b7b5f?w=800&h=600&fit=crop",
            duration: "9 Jours / 7 Nuits",
            minPersons: "2 personnes",
            description: "Un voyage fascinant au cœur du Brésil, entre la vitalité urbaine de São Paulo et l'énergie envoûtante de Rio de Janeiro. Une expérience complète mêlant culture, nature et ambiance tropicale, où se côtoient gratte-ciels, plages mythiques et rythmes de samba.",
            highlights: [
                "Découverte de São Paulo, métropole cosmopolite",
                "Séjour à Rio de Janeiro, la 'Cidade Maravilhosa'",
                "Montée au Corcovado et au Pain de Sucre",
                "Exploration du centre colonial et culturel",
                "Détente sur les plages de Copacabana et Ipanema"
            ]
        }
    ];

    const openBestSellerModal = (bestSeller) => {
        setSelectedBestSeller(bestSeller);
        setShowBestSellerModal(true);
    };

    const closeBestSellerModal = () => {
        setShowBestSellerModal(false);
        setSelectedBestSeller(null);
    };

    useEffect(() => {
        fetchFeaturedEvents();
    }, []);

    useEffect(() => {
        if (heroImages.length <= 1) return;
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [heroImages.length]);

    const location = useLocation();
    const navigate = useNavigate();

    const [hotelSearchParams, setHotelSearchParams] = useState({
        checkIn: '',
        checkOut: '',
        adultes: 2,
        enfants: 0,
        etoiles: 'Toutes',
        ville: 'Toutes les villes'
    });

    // Step 1 — capture the hash when the URL changes
    useEffect(() => {
        if (location.hash) setPendingHash(location.hash.replace('#', ''));
    }, [location.hash]);

    // Step 2 — scroll only once loading is done (layout is stable)
    useEffect(() => {
        if (loading || !pendingHash) return;
        const el = document.getElementById(pendingHash);
        if (!el) { setPendingHash(null); return; }
        const t = setTimeout(() => {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setPendingHash(null);
        }, 150);
        return () => clearTimeout(t);
    }, [loading, pendingHash]);
    const fetchFeaturedEvents = async () => {
        try {
            const response = await fetch(`${API}/events`);
            const result = await response.json();
            if (result.success) {
                // Filter to get only active voyage events
                const voyageEvents = result.data.filter(
                    event => event.category === 'voyage' && event.isActive
                );

                // Shuffle the array randomly
                const shuffled = voyageEvents.sort(() => Math.random() - 0.5);

                // Take up to 8 random events
                const featured = shuffled.slice(0, 8);

                setFeaturedEvents(featured);

                // Filter to get active sport events
                const sports = result.data.filter(
                    event => event.category === 'sport' && event.isActive
                );
                // Shuffle sport events and take up to 5
                const shuffledSports = sports.sort(() => Math.random() - 0.5).slice(0, 5);
                setSportEvents(shuffledSports);
            }
        } catch (error) {
            console.error('Error fetching events:', error);
        } finally {
            setLoading(false);
        }
    };

    const openModal = (event) => {
        setSelectedEvent(event);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedEvent(null);
    };



    const [formData, setFormData] = useState({
        nom_prenom: "",
        email: "",
        adresse: "",
        ville: "",
        telephone: "",
        whatsapp: "",
        mode_paiement: "",
        demande_specifique: "",
        demande_autre_details: "",
        remarque: "",
    });


    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleDemandeChange = (e) => {
        const val = e.target.value;
        setFormData((prev) => ({ ...prev, demande_specifique: val }));
        setShowOtherInput(val === "autres");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setMessage("");

        try {
            const response = await fetch(`${API}/reservations`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            if (result.success) {
                setMessage("Réservation envoyée avec succès.");
                setFormData({
                    nom_prenom: "",
                    email: "",
                    adresse: "",
                    ville: "",
                    telephone: "",
                    whatsapp: "",
                    mode_paiement: "",
                    demande_specifique: "",
                    demande_autre_details: "",
                    remarque: "",
                });
            } else {
                setMessage("Erreur lors de l'envoi de la réservation.");
            }
        } catch (error) {
            setMessage("Erreur serveur, veuillez réessayer plus tard.");
        } finally {
            setIsSubmitting(false);
        }
    };
    return (
        <>

            <Helmet>
                <title>Aviator Travel Services | Agence de Voyage en Tunisie - Voyages, Omra, Sport & Hôtels</title>
                <meta
                    name="description"
                    content="Découvrez Aviator Travel Services, votre agence de voyage en Tunisie. Circuits touristiques, voyages Omra, événements sportifs internationaux et réservations d'hôtels en Tunisie et à l'étranger. Voyagez sereinement avec nos offres exclusives"
                />
                <meta
                    name="keywords"
                    content="agence de voyage Tunisie, voyages organisés, Omra Tunisie, réservation hôtels Tunisie, voyages sportifs, billets d'avion Tunisie, circuit touristique, voyages à l'étranger, tourisme Tunisie, Aviator Travel Services"
                />
                <meta property="og:title" content="Aviator Travel Services - Agence de Voyage en Tunisie" />
                <meta property="og:description" content="Voyages, Omra, événements sportifs et hôtels en Tunisie et à l'étranger. Découvrez nos offres exclusives avec Aviator Travel Services." />
                <meta property="og:image" content="https://tonsite.com/assets/img/dest1.jpg" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://tonsite.com/" />
                <script type="application/ld+json">
                    {`
{
"@context":"https://schema.org",
"@type":"TravelAgency",
"name":"Aviator Travel Services",
"url":"https://tonsite.com/",
"logo":"https://tonsite.com/assets/img/logo.png",
"description":"Agence de voyage en Tunisie spécialisée dans les circuits touristiques, voyages Omra, événements sportifs et réservations d'hôtels.",
"address": {
"@type":"PostalAddress",
"addressCountry":"TN"
 },
"sameAs": [
"https://www.facebook.com/aviatortravelservices",
"https://www.instagram.com/aviatortravelservices"
 ]
}
`}
                </script>
            </Helmet>

            {/* Best Seller Modal */}
            {showBestSellerModal && selectedBestSeller && (
                <div
                    className="modal fade show"
                    style={{
                        display: 'block',
                        backgroundColor: 'rgba(0,0,0,0.7)',
                        backdropFilter: 'blur(5px)',
                        zIndex: 9999
                    }}
                    onClick={closeBestSellerModal}
                >
                    <div
                        className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered"
                        onClick={e => e.stopPropagation()}
                        style={{ maxWidth: '900px' }}
                    >
                        <div className="modal-content" style={{
                            border: 'none',
                            borderRadius: '20px',
                            overflow: 'hidden',
                            boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
                        }}>
                            <div className="modal-header position-relative" style={{
                                background: 'linear-gradient(135deg, #2B4C7E 0%, #567ebb 100%)',
                                color: 'white',
                                padding: '1.5rem',
                                border: 'none'
                            }}>
                                <div>
                                    <h5 className="modal-title fw-bold mb-1">{selectedBestSeller.title}</h5>
                                    <small className="text-white-50">
                                        <i className="fa fa-map-marker-alt me-2"></i>
                                        {selectedBestSeller.destination}
                                    </small>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={closeBestSellerModal}
                                    style={{ opacity: 1 }}
                                ></button>
                            </div>
                            <div className="modal-body" style={{ padding: '2rem' }}>
                                <div className="position-relative mb-4" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                                    <img
                                        src={selectedBestSeller.image}
                                        alt={selectedBestSeller.title}
                                        className="img-fluid w-100"
                                        style={{ maxHeight: '400px', objectFit: 'cover' }}
                                    />
                                    <div className="position-absolute top-0 start-0 m-3">
                                        <span className="badge bg-danger px-3 py-2" style={{ fontSize: '0.9rem' }}>
                                            <i className="fa fa-star me-2"></i>Best-Seller
                                        </span>
                                    </div>
                                </div>

                                <div className="row g-3 mb-4">
                                    <div className="col-6">
                                        <div className="p-3 text-center" style={{
                                            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                            borderRadius: '10px',
                                            border: '2px solid #2B4C7E'
                                        }}>
                                            <i className="fa fa-calendar-alt fa-2x mb-2" style={{ color: '#2B4C7E' }}></i>
                                            <p className="mb-0 small text-muted">Départs</p>
                                            <p className="mb-0 fw-bold">{selectedBestSeller.duration}</p>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="p-3 text-center" style={{
                                            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                            borderRadius: '10px',
                                            border: '2px solid #2B4C7E'
                                        }}>
                                            <i className="fa fa-users fa-2x mb-2" style={{ color: '#2B4C7E' }}></i>
                                            <p className="mb-0 small text-muted">Départ garanti dès</p>
                                            <p className="mb-0 fw-bold">{selectedBestSeller.minPersons}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}>
                                        <i className="fa fa-info-circle me-2"></i>Description
                                    </h5>
                                    <p className="text-muted" style={{ lineHeight: '1.8' }}>{selectedBestSeller.description}</p>
                                </div>

                                <div className="mb-4">
                                    <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}>
                                        <i className="fa fa-star me-2"></i>Points Forts du Voyage
                                    </h5>
                                    <div className="p-4" style={{
                                        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                        borderRadius: '15px',
                                        borderLeft: '4px solid #2B4C7E'
                                    }}>
                                        {selectedBestSeller.highlights.map((highlight, index) => (
                                            <p key={index} className="mb-2" style={{ lineHeight: '1.8' }}>
                                                <i className="fa fa-check text-success me-2"></i>{highlight}
                                            </p>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer" style={{
                                borderTop: '2px solid #e9ecef',
                                padding: '1.5rem 2rem'
                            }}>
                                <button
                                    type="button"
                                    className="btn btn-light px-4"
                                    onClick={closeBestSellerModal}
                                    style={{ borderRadius: '10px' }}
                                >
                                    Fermer
                                </button>
                                <a
                                    href="#res"
                                    className="btn text-white px-4"
                                    style={{
                                        background: 'linear-gradient(135deg, #2B4C7E 0%, #567ebb 100%)',
                                        borderRadius: '10px',
                                        boxShadow: '0 4px 15px rgba(43,76,126,0.3)'
                                    }}
                                    onClick={closeBestSellerModal}
                                >
                                    <i className="fa fa-calendar-check me-2"></i>Réserver Maintenant
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Enhanced Modal */}
            {showModal && selectedEvent && (
                <div
                    className="modal fade show"
                    style={{
                        display: 'block',
                        backgroundColor: 'rgba(0,0,0,0.7)',
                        backdropFilter: 'blur(5px)',
                        zIndex: 9999
                    }}
                    onClick={closeModal}
                >
                    <div
                        className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered"
                        onClick={e => e.stopPropagation()}
                        style={{ maxWidth: '900px' }}
                    >
                        <div className="modal-content" style={{
                            border: 'none',
                            borderRadius: '20px',
                            overflow: 'hidden',
                            boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
                        }}>
                            <div className="modal-header position-relative" style={{
                                background: 'linear-gradient(135deg, #2B4C7E 0%, #567ebb 100%)',
                                color: 'white',
                                padding: '1.5rem',
                                border: 'none'
                            }}>
                                <h5 className="modal-title fw-bold">{selectedEvent.title}</h5>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={closeModal}
                                    style={{ opacity: 1 }}
                                ></button>
                            </div>
                            <div className="modal-body" style={{ padding: '2rem' }}>
                                <div className="position-relative mb-4" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                                    <img
                                        src={selectedEvent.image}
                                        alt={selectedEvent.title}
                                        className="img-fluid w-100"
                                        style={{ maxHeight: '400px', objectFit: 'cover' }}
                                    />
                                    <div className="position-absolute bottom-0 start-0 w-100 p-3" style={{
                                        background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)'
                                    }}>
                                        <h6 className="text-white mb-0">
                                            <i className="fa fa-map-marker-alt me-2"></i>
                                            {selectedEvent.destination}
                                        </h6>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-between mb-4 p-3" style={{
                                    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                    borderRadius: '15px',
                                    border: '2px solid #2B4C7E'
                                }}>
                                    <div>
                                        <small className="text-muted d-block">Prix par personne</small>
                                        <h3 className="mb-0 fw-bold" style={{ color: '#2B4C7E' }}>
                                            {selectedEvent.departureDates && selectedEvent.departureDates.length > 0 && selectedEvent.departureDates[0].pricing?.b2c?.price
                                                ? selectedEvent.departureDates[0].pricing.b2c.price.toFixed(2)
                                                : "N/A"} <small>TND</small>
                                        </h3>
                                    </div>

                                    <div className="text-end">
                                        <i className="fa fa-plane fa-3x" style={{ color: '#2B4C7E', opacity: 0.3 }}></i>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}>
                                        <i className="fa fa-info-circle me-2"></i>Description
                                    </h5>
                                    <p className="text-muted" style={{ lineHeight: '1.8' }}>{selectedEvent.description}</p>
                                </div>

                                {selectedEvent.program && (
                                    <div className="mb-4">
                                        <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}>
                                            <i className="fa fa-list-ul me-2"></i>Programme
                                        </h5>
                                        <div className="p-4" style={{
                                            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                            borderRadius: '15px',
                                            borderLeft: '4px solid #2B4C7E'
                                        }}>
                                            {selectedEvent.program.split('\n').map((line, index) => (
                                                <p key={index} className="mb-2" style={{ lineHeight: '1.8' }}>
                                                    <i className="fa fa-check text-success me-2"></i>{line}
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {selectedEvent.voldetails && (
                                    <div className="mb-4">
                                        <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}>
                                            <i className="fa fa-plane-departure me-2"></i>Détails du Vol
                                        </h5>
                                        <div className="p-3" style={{
                                            background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                                            borderRadius: '15px'
                                        }}>
                                            <p className="mb-0" style={{ lineHeight: '1.8' }}>{selectedEvent.voldetails}</p>
                                        </div>
                                    </div>
                                )}

                                {selectedEvent.includedServices && selectedEvent.excludedServices && (
                                    <div className="row g-4 mb-4">
                                        <div className="col-md-6">
                                            <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}>
                                                <i className="fa fa-check-circle me-2"></i>Services Inclus
                                            </h5>
                                            <ul className="list-group" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                                                {selectedEvent.includedServices.map((service, index) => (
                                                    <li key={index} className="list-group-item border-0 mb-2" style={{
                                                        background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)',
                                                        borderRadius: '10px'
                                                    }}>
                                                        <i className="fa fa-check-circle text-success me-2"></i>
                                                        {service}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="col-md-6">
                                            <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}>
                                                <i className="fa fa-times-circle me-2"></i>Services Non Inclus
                                            </h5>
                                            <ul className="list-group" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                                                {selectedEvent.excludedServices.map((service, index) => (
                                                    <li key={index} className="list-group-item border-0 mb-2" style={{
                                                        background: 'linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%)',
                                                        borderRadius: '10px'
                                                    }}>
                                                        <i className="fa fa-times-circle text-danger me-2"></i>
                                                        {service}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer" style={{
                                borderTop: '2px solid #e9ecef',
                                padding: '1.5rem 2rem'
                            }}>
                                <button
                                    type="button"
                                    className="btn btn-light px-4"
                                    onClick={closeModal}
                                    style={{ borderRadius: '10px' }}
                                >
                                    Fermer
                                </button>
                                <a
                                    href="#res"
                                    className="btn text-white px-4"
                                    style={{
                                        background: 'linear-gradient(135deg, #2B4C7E 0%, #567ebb 100%)',
                                        borderRadius: '10px',
                                        boxShadow: '0 4px 15px rgba(43,76,126,0.3)'
                                    }}
                                    onClick={closeModal}
                                >
                                    <i className="fa fa-calendar-check me-2"></i>Réserver Maintenant
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div>
                <div className="container-fluid bg-primary py-5 mb-5 hero-header" style={{ position: "relative", overflow: "hidden", minHeight: "100vh" }}>
                    {/* Dark placeholder — fades out once first image is ready */}
                    <div style={{ position: 'absolute', inset: 0, backgroundColor: '#0a1628', opacity: firstImageReady ? 0 : 1, transition: 'opacity 0.7s ease', zIndex: 5, pointerEvents: 'none' }} />
                    {heroImages.map((image, index) => (
                        <div
                            key={index}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                minHeight: "100%",
                                backgroundImage: `url(${image})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                opacity: currentImageIndex === index ? 1 : 0,
                                transition: "opacity 1s ease-in-out",
                                zIndex: 1
                            }}
                        />
                    ))}

                    <div style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        minHeight: "100%",
                        background: "linear-gradient(to bottom, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.25) 40%, rgba(0,0,0,0) 70%)",
                        zIndex: 2
                    }} />

                    <div className="container py-5" style={{ position: "relative", zIndex: 10 }}>
                        <div className="row justify-content-center py-5">
                            <div className="col-lg-10 text-center">
                                <h1 className="display-3 text-white mb-3 animated slideInDown" style={{ fontWeight: '700' }}>
                                    FUN FOR ALL, ALL FOR FUN
                                </h1>
                                <p className="fs-4 text-white mb-4 animated slideInDown">
                                    Votre prochaine aventure commence ici
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* SEARCH WIDGET EXTRA LAYER OVER HERO */}
                    <div className="container position-relative" style={{ zIndex: 20, marginTop: '-50px' }}>
                        <div className="row justify-content-center">
                            <div className="col-12 col-xl-11">
                                {/* Frosted Glass Outer Container */}
                                <div
                                    className="p-2 p-md-3"
                                    style={{
                                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                        backdropFilter: 'blur(8px)',
                                        WebkitBackdropFilter: 'blur(8px)',
                                        borderRadius: '16px',
                                        boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
                                    }}
                                >
                                    {/* Tabs */}
                                    <div className="d-flex" style={{ gap: '0' }}>
                                        <button
                                            className="btn py-3 px-4 fw-bold border-0"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                color: '#01225B',
                                                fontSize: '16px',
                                                borderTopLeftRadius: '12px',
                                                borderTopRightRadius: '0',
                                                borderBottomLeftRadius: '0',
                                                borderBottomRightRadius: '0',
                                            }}
                                        >
                                            Hôtels en Tunisie
                                        </button>
                                        <button
                                            className="btn py-3 px-4 fw-bold border-0"
                                            onClick={() => navigate('/voyage')}
                                            style={{
                                                backgroundColor: '#01225B',
                                                color: '#ffffff',
                                                fontSize: '16px',
                                                borderTopLeftRadius: '0',
                                                borderTopRightRadius: '12px',
                                                borderBottomLeftRadius: '0',
                                                borderBottomRightRadius: '0',
                                            }}
                                        >
                                            Voyages organisés
                                        </button>
                                    </div>

                                    {/* Form Body */}
                                    <div
                                        className="bg-white p-3 p-md-4"
                                        style={{
                                            borderTopRightRadius: '12px',
                                            borderBottomLeftRadius: '12px',
                                            borderBottomRightRadius: '12px',
                                            borderTopLeftRadius: '0'
                                        }}
                                    >
                                        <div className="row g-2 g-xl-3 align-items-stretch">
                                            {/* Check-In */}
                                            <div className="col-12 col-md-4 col-lg-2 d-flex flex-column">
                                                <label className="fw-bold mb-2" style={{ color: '#01225B', fontSize: '14px' }}>
                                                    <i className="fa fa-calendar-alt me-2"></i>Check-In
                                                </label>
                                                <input type="date" className="form-control flex-grow-1" value={hotelSearchParams.checkIn} onChange={(e) => setHotelSearchParams({ ...hotelSearchParams, checkIn: e.target.value })} style={{ borderColor: '#ddd', padding: '10px 12px', borderRadius: '8px' }} />
                                            </div>

                                            {/* Check-Out */}
                                            <div className="col-12 col-md-4 col-lg-2 d-flex flex-column">
                                                <label className="fw-bold mb-2" style={{ color: '#01225B', fontSize: '14px' }}>
                                                    <i className="fa fa-calendar-alt me-2"></i>Check-Out
                                                </label>
                                                <input type="date" className="form-control flex-grow-1" value={hotelSearchParams.checkOut} onChange={(e) => setHotelSearchParams({ ...hotelSearchParams, checkOut: e.target.value })} style={{ borderColor: '#ddd', padding: '10px 12px', borderRadius: '8px' }} />
                                            </div>

                                            {/* Adultes */}
                                            <div className="col-6 col-md-2 col-lg d-flex flex-column">
                                                <label className="fw-bold mb-2" style={{ color: '#01225B', fontSize: '14px' }}>
                                                    <i className="fa fa-user me-2"></i>Adultes
                                                </label>
                                                <input type="number" min="1" value={hotelSearchParams.adultes} onChange={(e) => setHotelSearchParams({ ...hotelSearchParams, adultes: e.target.value })} className="form-control flex-grow-1" style={{ borderColor: '#ddd', padding: '10px 12px', borderRadius: '8px' }} />
                                            </div>

                                            {/* Enfants */}
                                            <div className="col-6 col-md-2 col-lg d-flex flex-column">
                                                <label className="fw-bold mb-2" style={{ color: '#01225B', fontSize: '14px' }}>
                                                    <i className="fa fa-child me-2"></i>Enfants
                                                </label>
                                                <input type="number" min="0" value={hotelSearchParams.enfants} onChange={(e) => setHotelSearchParams({ ...hotelSearchParams, enfants: e.target.value })} className="form-control flex-grow-1" style={{ borderColor: '#ddd', padding: '10px 12px', borderRadius: '8px' }} />
                                            </div>

                                            {/* Etoiles */}
                                            <div className="col-12 col-md-4 col-lg-2 d-flex flex-column">
                                                <label className="fw-bold mb-2" style={{ color: '#01225B', fontSize: '14px' }}>
                                                    <i className="fa fa-star me-2"></i>Étoiles
                                                </label>
                                                <select className="form-select form-control text-muted flex-grow-1" value={hotelSearchParams.etoiles} onChange={(e) => setHotelSearchParams({ ...hotelSearchParams, etoiles: e.target.value })} style={{ borderColor: '#ddd', padding: '10px 12px', borderRadius: '8px' }}>
                                                    <option>Toutes</option>
                                                    <option>5 Étoiles</option>
                                                    <option>4 Étoiles</option>
                                                    <option>3 Étoiles</option>
                                                </select>
                                            </div>

                                            {/* Ville */}
                                            <div className="col-12 col-md-4 col-lg-2 d-flex flex-column">
                                                <label className="fw-bold mb-2" style={{ color: '#01225B', fontSize: '14px' }}>
                                                    <i className="fa fa-map-marker-alt me-2"></i>Ville
                                                </label>
                                                <select className="form-select form-control text-muted flex-grow-1" value={hotelSearchParams.ville} onChange={(e) => setHotelSearchParams({ ...hotelSearchParams, ville: e.target.value })} style={{ borderColor: '#ddd', padding: '10px 12px', borderRadius: '8px' }}>
                                                    <option>Toutes les villes</option>
                                                    <option>Hammamet</option>
                                                    <option>Sousse</option>
                                                    <option>Djerba</option>
                                                    <option>Tunis</option>
                                                </select>
                                            </div>

                                            {/* Submit Button */}
                                            <div className="col-12 col-md-4 col-lg-2 col-xl-1 d-flex flex-column">
                                                <button
                                                    className="btn w-100 flex-grow-1 d-flex justify-content-center align-items-center mt-lg-0 mt-3 border-0"
                                                    onClick={() => navigate('/hotelstn', { state: { searchParams: hotelSearchParams } })}
                                                    style={{
                                                        backgroundColor: '#FFBC1E',
                                                        color: '#ffffff',
                                                        borderRadius: '12px',
                                                        minHeight: '60px'
                                                    }}
                                                >
                                                    <i className="fa fa-search fs-3"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* END SEARCH WIDGET */}
                </div>



                {/* Enhanced Destination Section with Dynamic Events */}
                <PopularDestinations title="Destinations Populaires" subtitle="Best Sellers" category="voyage" limit={8} />

                {/* Package Start
 <div className="container-xxl py-5">
 <div className="container">
 <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
 <h6 className="section-title bg-white text-center px-3" style={{ color: '#2B4C7E', borderColor: '#2B4C7E' }}> 
 Forfaits
 </h6>
 <h1 className="mb-5">Forfaits Exceptionnels</h1>
 </div>
 <div className="row g-4 justify-content-center">
 <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
 <div className="package-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/package-1.jpg" alt="" />
 </div>
 <div className="d-flex border-bottom">
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-map-marker-alt text-primary me-2" />
 Thaïlande
 </small>
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-calendar-alt text-primary me-2" />3 jours
 </small>
 <small className="flex-fill text-center py-2">
 <i className="fa fa-user text-primary me-2" />2 Personnes
 </small>
 </div>
 <div className="text-center p-4">
 <h3 className="mb-0">149,00 </h3>
 <div className="mb-3">
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 </div>
 <div className="d-flex justify-content-center mb-2">
 <a
 href="#"
 className="btn btn-sm px-3 border-end"
 style={{ borderRadius:"30px 0 0 30px", backgroundColor: '#2B4C7E', color: 'white'}}
 >
 Lire Plus
 </a>
 <a
 href="#"
 className="btn btn-sm btn-primary px-3"
 style={{ borderRadius:"0 30px 30px 0", backgroundColor: '#2B4C7E', color: 'white', borderColor: '#2B4C7E' }}
 >
 Réserver
 </a>
 </div>
 </div>
 </div>
 </div>
 <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
 <div className="package-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/package-2.jpg" alt="" />
 </div>
 <div className="d-flex border-bottom">
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-map-marker-alt text-primary me-2" />
 Indonésie
 </small>
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-calendar-alt text-primary me-2" />3 jours
 </small>
 <small className="flex-fill text-center py-2">
 <i className="fa fa-user text-primary me-2" />2 Personnes
 </small>
 </div>
 <div className="text-center p-4">
 <h3 className="mb-0">139,00 </h3>
 <div className="mb-3">
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 </div>
 <div className="d-flex justify-content-center mb-2">
 <a
 href="#"
 className="btn btn-sm btn-primary px-3 border-end"
 style={{ borderRadius:"30px 0 0 30px", backgroundColor: '#2B4C7E', color: 'white', borderColor: '#2B4C7E' }}
 >
 Lire Plus
 </a>
 <a
 href="#"
 className="btn btn-sm btn-primary px-3"
 style={{ borderRadius:"0 30px 30px 0", backgroundColor: '#2B4C7E', color: 'white', borderColor: '#2B4C7E' }}
 >
 Réserver
 </a>
 </div>
 </div>
 </div>
 </div>
 <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
 <div className="package-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/package-3.jpg" alt="" />
 </div>
 <div className="d-flex border-bottom">
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-map-marker-alt text-primary me-2" />
 Malaisie
 </small>
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-calendar-alt text-primary me-2" />3 jours
 </small>
 <small className="flex-fill text-center py-2">
 <i className="fa fa-user text-primary me-2" />2 Personnes
 </small>
 </div>
 <div className="text-center p-4">
 <h3 className="mb-0">189,00 </h3>
 <div className="mb-3">
 <small className="fa fa-star text-primary" style={{ color: '#2B4C7E', borderColor: '#2B4C7E' }}/>
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 </div>
 <div className="d-flex justify-content-center mb-2">
 <a
 href="#"
 className="btn btn-sm btn-primary px-3 border-end"
 style={{ borderRadius:"30px 0 0 30px", backgroundColor: '#2B4C7E', color: 'white', borderColor: '#2B4C7E' }}
 >
 Lire Plus
 </a>
 <a
 href="#"
 className="btn btn-sm btn-primary px-3"
 style={{ borderRadius:"0 30px 30px 0", backgroundColor: '#2B4C7E', color: 'white', borderColor: '#2B4C7E' }}
 >
 Réserver
 </a>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div> */}
                {/* Package End */}

                {/* Best Sellers Section Start */}


                {/* Best Sellers Section End */}
                {/* Best Sellers Section End */}



                {/* Sport dans le Monde Start */}
                <div className="container-fluid py-5 mt-5" style={{ backgroundColor: '#EEF4FE' }}>
                    <div className="container">
                        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                            <h6 className="text-center px-3" style={{ color: '#00338C', fontSize: '28px', fontWeight: 500, backgroundColor: '#EEF4FE', fontFamily: "'Inter', sans-serif !important" }}>
                                Événements Sportifs
                            </h6>
                            <h1 className="mb-5" style={{ color: '#01225C', fontWeight: 'bold', fontSize: '48px' }}>Sport dans le Monde</h1>
                        </div>

                        {loading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border" style={{ color: '#00338C', width: '3rem', height: '3rem' }} role="status">
                                    <span className="visually-hidden">Chargement...</span>
                                </div>
                            </div>
                        ) : sportEvents.length > 0 ? (
                            <div className="row g-4 px-4 justify-content-center">
                                {sportEvents.map((event, index) => {
                                    const colClass = index < 2 ? "col-lg-6 col-md-6 col-sm-12" : "col-lg-4 col-md-6 col-sm-12";

                                    let evYear = "2026";
                                    let evDateStr = "";
                                    if (event.departureDates && event.departureDates.length > 0) {
                                        const d = new Date(event.departureDates[0].departureDate);
                                        evYear = d.getFullYear().toString();
                                        evDateStr = `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
                                    }

                                    return (
                                        <div className={`${colClass} wow fadeInUp`} data-wow-delay={`0.${(index % 3) + 1}s`} key={event._id || index}>
                                            <div
                                                className="service-item"
                                                style={{
                                                    overflow: 'hidden',
                                                    boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
                                                    transition: 'all 0.3s ease',
                                                    cursor: 'pointer',
                                                    display: 'block',
                                                    borderRadius: '12px'
                                                }}
                                                onClick={() => openModal(event)}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.boxShadow = '0 5px 20px rgba(0,0,0,0.1)';
                                                }}
                                            >
                                                <div className="position-relative" style={{ height: '300px', overflow: 'hidden', borderRadius: '12px' }}>
                                                    <img
                                                        className="img-fluid w-100 h-100"
                                                        src={event.image || 'assets/img/worldcup.jpg'}
                                                        alt={event.title}
                                                        style={{ objectFit: 'cover' }}
                                                    />

                                                    <div className="position-absolute top-0 start-0 w-100 h-100" style={{
                                                        background: 'linear-gradient(to top, rgba(1,34,92,0.95) 0%, rgba(1,34,92,0) 50%, rgba(0,0,0,0) 100%)'
                                                    }}>
                                                        <div className="position-absolute top-0 end-0 m-3" style={{
                                                            backgroundColor: '#FFBC1E',
                                                            color: '#fff',
                                                            fontWeight: 'bold',
                                                            fontSize: '12px',
                                                            padding: '4px 10px',
                                                            borderRadius: '4px'
                                                        }}>
                                                            {evYear}
                                                        </div>

                                                        <div className="position-absolute bottom-0 start-0 w-100 p-4">
                                                            <h4 className="text-white fw-bold mb-2" style={{ fontSize: index < 2 ? '24px' : '20px' }}>
                                                                {event.title}
                                                            </h4>
                                                            <p className="text-white mb-2" style={{ fontSize: '14px', opacity: 0.9 }}>
                                                                {event.destination}
                                                            </p>
                                                            {evDateStr && (
                                                                <p className="mb-0 text-white" style={{ fontSize: '12px', opacity: 0.8 }}>
                                                                    <i className="fa fa-calendar-alt me-2"></i>{evDateStr}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="text-center py-5">
                                <p className="text-muted">Aucun événement sportif pour le moment.</p>
                            </div>
                        )}

                        <div className="text-center mt-5 mb-3">
                            <button
                                className="btn"
                                style={{
                                    backgroundColor: '#01225C',
                                    color: 'white',
                                    padding: '10px 30px',
                                    fontWeight: 'bold',
                                    transition: 'all 0.3s',
                                    borderRadius: '12px'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#00338C';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#01225C';
                                }}
                            >
                                Découvrir plus
                            </button>
                        </div>

                    </div>
                </div>
                {/* Sport dans le Monde End */}



                <Processus />

                {/* Booking Start */}
                <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s" id="res" style={{ backgroundColor: '#EEF4FE', fontFamily: "'Inter', sans-serif" }}>
                    <div className="container">
                        <div className="booking p-5" style={{ borderRadius: '10px', position: 'relative', overflow: 'hidden' }}>
                            <div className="row g-5 align-items-center position-relative" style={{ zIndex: 1 }}>
                                <div className="col-md-6 text-white pe-lg-5">
                                    <h6 className="text-white mb-2" style={{ fontSize: '1.25rem', fontWeight: 500 }}>Réservation en ligne</h6>
                                    <h1 className="text-white mb-4 fw-bold" style={{ fontSize: '3rem' }}>Demander un devis</h1>
                                    <p className="mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                                        Où que vos rêves vous mènent vos rêves, nous veillerons à ce que chaque détail soit parfait.
                                        Découvrez des destinations exclusives, comparez les meilleurs hôtels et réservez en toute confiance — tout en un seul endroit.
                                    </p>
                                    <p className="mb-4 fw-bold" style={{ fontSize: '1.1rem' }}>
                                        Commencez votre prochaine aventure aujourd'hui.
                                    </p>
                                </div>
                                <div className="col-md-6">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row g-3">

                                            <div className="col-12">
                                                <div className="form-floating">
                                                    <select
                                                        className="form-select bg-transparent text-white"
                                                        style={{ borderRadius: '10px', border: '1px solid rgba(255,255,255,0.7)', color: 'white' }}
                                                        id="sujet"
                                                        required
                                                    >
                                                        <option value="" style={{ color: '#000' }}>Sélectionner le sujet...</option>
                                                        <option value="circuit" style={{ color: '#000' }}>Circuit Touristique</option>
                                                        <option value="omra" style={{ color: '#000' }}>Omra</option>
                                                        <option value="hotel" style={{ color: '#000' }}>Hôtel</option>
                                                    </select>
                                                    <label htmlFor="sujet" className="text-white-50">Sujet *</label>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <input
                                                        type="text"
                                                        name="nom_prenom"
                                                        className="form-control bg-transparent text-white"
                                                        style={{ borderRadius: '10px', border: '1px solid rgba(255,255,255,0.7)' }}
                                                        id="nom_prenom"
                                                        placeholder="Nom et Prénom"
                                                        value={formData.nom_prenom}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                    <label htmlFor="nom_prenom" className="text-white-50">Nom et Prénom</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        className="form-control bg-transparent text-white"
                                                        style={{ borderRadius: '10px', border: '1px solid rgba(255,255,255,0.7)' }}
                                                        id="email"
                                                        placeholder="Adresse Email"
                                                        required
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                    />
                                                    <label htmlFor="email" className="text-white-50">Adresse Email</label>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="form-floating">
                                                    <input
                                                        type="text"
                                                        name="adresse"
                                                        className="form-control bg-transparent text-white"
                                                        style={{ borderRadius: '10px', border: '1px solid rgba(255,255,255,0.7)' }}
                                                        id="adresse"
                                                        placeholder="Adresse Complète"
                                                        required
                                                        value={formData.adresse}
                                                        onChange={handleChange}
                                                    />
                                                    <label htmlFor="adresse" className="text-white-50">Adresse Complète</label>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <input
                                                        type="text"
                                                        name="ville"
                                                        className="form-control bg-transparent text-white"
                                                        style={{ borderRadius: '10px', border: '1px solid rgba(255,255,255,0.7)' }}
                                                        id="ville"
                                                        placeholder="Ville"
                                                        required
                                                        value={formData.ville}
                                                        onChange={handleChange}
                                                    />
                                                    <label htmlFor="ville" className="text-white-50">Ville</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <input
                                                        type="tel"
                                                        name="telephone"
                                                        className="form-control bg-transparent text-white"
                                                        style={{ borderRadius: '10px', border: '1px solid rgba(255,255,255,0.7)' }}
                                                        id="telephone"
                                                        placeholder="Téléphone"
                                                        required
                                                        value={formData.telephone}
                                                        onChange={handleChange}
                                                    />
                                                    <label htmlFor="telephone" className="text-white-50">Téléphone</label>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <input
                                                        type="tel"
                                                        name="whatsapp"
                                                        className="form-control bg-transparent text-white"
                                                        style={{ borderRadius: '10px', border: '1px solid rgba(255,255,255,0.7)' }}
                                                        id="whatsapp"
                                                        placeholder="WhatsApp"
                                                        value={formData.whatsapp}
                                                        onChange={handleChange}
                                                    />
                                                    <label htmlFor="whatsapp" className="text-white-50">WhatsApp</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <select
                                                        name="mode_paiement"
                                                        className="form-select bg-transparent text-white"
                                                        style={{ borderRadius: '10px', border: '1px solid rgba(255,255,255,0.7)', color: 'white' }}
                                                        id="mode_paiement"
                                                        required
                                                        value={formData.mode_paiement}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="" style={{ color: '#000' }}>Sélectionner...</option>
                                                        <option value="especes" style={{ color: '#000' }}>Espèces</option>
                                                        <option value="carte" style={{ color: '#000' }}>Carte Bancaire</option>
                                                        <option value="virement" style={{ color: '#000' }}>Virement</option>
                                                        <option value="autre" style={{ color: '#000' }}>Autre </option>
                                                    </select>
                                                    <label htmlFor="mode_paiement" className="text-white-50">Mode de Paiement</label>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="form-floating">
                                                    <select
                                                        name="demande_specifique"
                                                        className="form-select bg-transparent text-white"
                                                        style={{ borderRadius: '10px', border: '1px solid rgba(255,255,255,0.7)', color: 'white' }}
                                                        id="demande_specifique"
                                                        value={formData.demande_specifique}
                                                        onChange={handleDemandeChange}
                                                        required
                                                    >
                                                        <option value="" style={{ color: '#000' }}>Demande spécifique / Demander un devis</option>
                                                        <option value="informations_generales" style={{ color: '#000' }}>Informations générales</option>
                                                        <option value="voyage_sur_mesure" style={{ color: '#000' }}>Voyage sur mesure</option>
                                                        <option value="hotels_a_letranger" style={{ color: '#000' }}>Hôtels à l’étranger</option>
                                                        <option value="excursions_a_letranger" style={{ color: '#000' }}>Excursions à l’étranger</option>
                                                        <option value="demande_de_visa" style={{ color: '#000' }}>Demande de visa</option>
                                                        <option value="autres" style={{ color: '#000' }}>Autres demandes</option>
                                                    </select>
                                                    <label htmlFor="demande_specifique" className="text-white-50">Demande spécifique</label>
                                                </div>
                                            </div>

                                            {showOtherInput && (
                                                <div className="col-12">
                                                    <div className="form-floating">
                                                        <input
                                                            type="text"
                                                            name="demande_autre_details"
                                                            className="form-control bg-transparent text-white"
                                                            style={{ borderRadius: '10px', border: '1px solid rgba(255,255,255,0.7)' }}
                                                            id="demande_autre_details"
                                                            placeholder="Entrez vos détails"
                                                            value={formData.demande_autre_details}
                                                            onChange={handleChange}
                                                        />
                                                        <label htmlFor="demande_autre_details" className="text-white-50">Veuillez préciser</label>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="col-12">
                                                <div className="form-floating">
                                                    <textarea
                                                        name="remarque"
                                                        className="form-control bg-transparent text-white"
                                                        style={{ borderRadius: '10px', border: '1px solid rgba(255,255,255,0.7)', height: '100px' }}
                                                        placeholder="Remarque"
                                                        id="remarque"
                                                        value={formData.remarque}
                                                        onChange={handleChange}
                                                    />
                                                    <label htmlFor="remarque" className="text-white-50">Remarque</label>
                                                </div>
                                            </div>

                                            <input type="hidden" name="_next" value="http://localhost:3000/" />

                                            <div className="col-12 text-center mt-4">
                                                <button
                                                    className="btn fw-bold px-5 py-3"
                                                    type="submit"
                                                    style={{
                                                        backgroundColor: 'white',
                                                        color: '#01225C',
                                                        borderRadius: '10px',
                                                        minWidth: '200px'
                                                    }}
                                                >
                                                    {isSubmitting ? "Envoi en cours..." : "Réserver Maintenant"}
                                                </button>
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Booking End */}
            </div>

            {/* Make Memories Section */}
            <div className="container-fluid py-5" style={{ fontFamily: "'Inter', sans-serif" }}>
                <div className="container text-center">
                    <h2 className="mb-5 fw-bold" style={{ color: '#01225C', fontSize: '2.5rem', fontFamily: "'Inter', sans-serif" }}>Make memories with us</h2>
                    <div className="row g-4 justify-content-center px-3">
                        {[1, 2, 3, 4, 5].map((num) => (
                            <div className="col-12 col-sm-8 col-md-6 col-lg" key={num}>
                                <a
                                    href="https://www.instagram.com/aviator_travel_services/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="d-block position-relative overflow-hidden"
                                    style={{
                                        borderRadius: '15px',
                                        aspectRatio: '1 / 1',
                                        cursor: 'pointer',
                                        textDecoration: 'none'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.querySelector('.memorie-img').style.transform = 'scale(1.1)';
                                        e.currentTarget.querySelector('.memorie-overlay').style.opacity = '1';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.querySelector('.memorie-img').style.transform = 'scale(1)';
                                        e.currentTarget.querySelector('.memorie-overlay').style.opacity = '0';
                                    }}
                                >
                                    <img
                                        src={`assets/img/memorie${num}.png`}
                                        alt={`Memory ${num}`}
                                        className="w-100 h-100 memorie-img"
                                        style={{
                                            objectFit: 'cover',
                                            transition: 'transform 0.5s ease'
                                        }}
                                    />
                                    <div
                                        className="memorie-overlay position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                                        style={{
                                            backgroundColor: 'rgba(0,0,0,0.4)',
                                            opacity: '0',
                                            transition: 'opacity 0.3s ease',
                                            zIndex: 1
                                        }}
                                    >
                                        <i className="fab fa-instagram text-white mb-2" style={{ fontSize: '2rem' }}></i>
                                        <span className="text-white" style={{ fontSize: '0.9rem', fontWeight: '500' }}>@aviator_travel_services</span>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

        </>
    )
}